import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";

import { ScrollDirection, useDetectScroll } from "@utils/hooks/useDetectScroll";

import { getProductComparisonSkuList } from "@redux/modules/value/productComparisonSkuList/productComparisonSkuList.selectors";
import { getProductDetail } from "@redux/modules/value/productDetail/productDetail.selectors";

import { BackToTopComponent } from "./backToTop.component";

const BACK_TO_TOP_VISIBLE_AT = 400;

const BackToTop = () => {
    const hasComparison = !!useSelector(getProductComparisonSkuList)?.length;
    const hasOrderButton = useSelector(
        getProductDetail,
        shallowEqual,
    ).stickyOrderButton;

    const { direction } = useDetectScroll();

    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const updateVisibility = () =>
            setVisible(
                () =>
                    window.scrollY > BACK_TO_TOP_VISIBLE_AT &&
                    direction !== ScrollDirection.Down,
            );

        updateVisibility();
        document.addEventListener("scroll", updateVisibility);
        return () => document.removeEventListener("scroll", updateVisibility);
    }, [setVisible, direction]);

    return (
        <BackToTopComponent
            visible={visible}
            bottomControlsVisible={hasComparison || hasOrderButton}
        />
    );
};

export { BackToTop };
